import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import axios from 'axios';
import { environment } from 'environments/environment';
import { from } from 'rxjs';
import { AuthService } from './authentication.service';
@Injectable({ providedIn: 'root' })
export class S3UploadService {
  
  constructor(private http: HttpClient,private auth: AuthService) {}

  getPresignedUrl(file: File) {
    const phoenixURL = environment.phoenixURL;
    const url = phoenixURL.split('/phoenix')[0];
    const bodyObj = {
      "filename": `${file.name}`,
      "expiresIn": 60,
      "contentType":`${file.type}`
    }
    return from(
      axios.post(url + '/upload/api/v1/sign-s3', bodyObj)
    );
  }

  uploadToS3(url: string, file: File) {
    return from(
      axios.put(url, file, {
        headers: {
          'Content-Type': file.type
        }
      })
    );
  }

  uploadToS3Video(formData:any,token:string) {
    const phoenixURL = environment.phoenixURL;
    const url = phoenixURL.split('/phoenix')[0];
    console.log(url);    
    return from(
      axios.post(`${url}/upload/api/v1/upload?access_token=`+token, formData, {
        headers: {
         'Content-Type': 'multipart/form-data'
        }
      })
    );
  }
  
}
